<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.70833 0.729126C3.40613 0.729126 0.729164 3.40609 0.729164 6.70829C0.729164 10.0105 3.40613 12.6875 6.70833 12.6875C10.0105 12.6875 12.6875 10.0105 12.6875 6.70829C12.6875 3.40609 10.0105 0.729126 6.70833 0.729126ZM1.60416 6.70829C1.60416 3.88934 3.88938 1.60413 6.70833 1.60413C9.52728 1.60413 11.8125 3.88934 11.8125 6.70829C11.8125 9.52725 9.52728 11.8125 6.70833 11.8125C3.88938 11.8125 1.60416 9.52725 1.60416 6.70829Z"
      fill="#9A9A9A"
    />
    <path
      d="M12.6969 13.398L13.3569 12.7381L11.9717 11.3529L11.3117 12.0129L12.6969 13.398Z"
      fill="#9A9A9A"
    />
  </svg>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
